import Icon from "@ant-design/icons";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ReloadOutlined(props) {
  return /*#__PURE__*/_jsxs(Icon, {
    ...props,
    viewBox: "0 0 512 512",
    children: [/*#__PURE__*/_jsx("path", {
      style: {
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeMiterlimit: "10",
        strokeWidth: "40px"
      },
      d: "M320,146s24.36-12-64-12A160,160,0,1,0,416,294"
    }), /*#__PURE__*/_jsx("polyline", {
      style: {
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "40px"
      },
      points: "256 58 336 138 256 218"
    })]
  });
}